import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const CropContainer = styled.div`
  background-color: #333333;
  position: relative;
  width: 100%;
  height: 250px;
  margin-top: 10px;
` 

export const Image = styled.img`
  width: 250px;
  height: 250px;
  margin-bottom: 10px;
  border-radius: 15px;
  box-shadow: 0px 2px 10px -6px #252525;
`

export const SmallImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 20px;
  align-self: center;
  margin-bottom: 20px;
  box-shadow: 0px 2px 10px -6px #252525;
`

export const Button = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'secondary' }))`
  width: 200px;
  align-self: center;
`

export const DangerButton = styled(LookButton).attrs({ type: 'button' }).attrs(buttonLook({ variant: 'primary', destructive: true }))`
  width: 200px;
  align-self: center;
  margin-top: 10px;
`

export const ControlsContainer = styled.div`
  width: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-self: center;
  align-self: center;
  gap: 8px;

  p {margin-bottom: 3px;}

  &:hover input[type='range']::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px 8px #35A7FF33;
    border-radius: 50%;
  }

  &:hover input[type='range']::-moz-range-thumb {
    box-shadow: 0px 0px 0px 8px #35A7FF33;
  }
`

export const RangeInput = styled.input.attrs ({
  type: 'range',
  min: 1,
  max: 3,
  step: 0.1
})`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 2px;
  background: #35A7FF;
  width: 100%;

  ::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #35A7FF;
    background: #35A7FF;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  ::-moz-range-thumb {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #35A7FF;
    background: #35A7FF;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`

export const InfoText = styled.p`
  text-align: center;
  color: #000000;
  margin-bottom: 5px;
`

export const ButtonText = styled(InfoText)`
  color: #FFFFFF;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-top: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
